import { Grid } from '@mui/material';
import { ChartBox, SlideParagraph, SlideTitle } from 'features/slides';
import { PortfolioStatisticsBarChart } from 'pages/Cases/components/PortfolioStatisticsBarChart';
import SummaryPerformanceTable from 'pages/Cases/components/SummaryPerformanceTable';
import {
  columnsTrailingYearReturns,
  getPortfolioStatisticsRows,
  portfolioStatisticsAnnualChartFormatedNames,
  portfolioStatisticsChartFilter,
} from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';
import React from 'react';

export type AnnualizedReturnsProps = {
  readonly filteredPerformance: any;
  readonly rowsAnnualizedReturnsTable?: boolean;
};

export function AnnualizedReturns({
  filteredPerformance,
  rowsAnnualizedReturnsTable,
}: AnnualizedReturnsProps): React.ReactElement {
  return (
    <Grid
      container
      flexDirection="column"
      gap={0}
      sx={{
        width: '100%',
        padding: '10px',
      }}
    >
      <Grid
        container
        sx={{
          marginBottom: '6px',
        }}
      >
        <SlideTitle>Annualized Returns</SlideTitle>
      </Grid>

      <ChartBox>
        <PortfolioStatisticsBarChart
          data={portfolioStatisticsAnnualChartFormatedNames(
            filteredPerformance,
            columnsTrailingYearReturns,
          )}
          ytdFinal={false}
          height={rowsAnnualizedReturnsTable ? 400 : 500}
          isWithAnimation={false}
          formatChart={{
            label: 'Return (%)',
          }}
        />
      </ChartBox>
      {rowsAnnualizedReturnsTable && (
        <Grid sx={{ width: '100%', backgroundColor: '#fff' }}>
          <SummaryPerformanceTable
            rows={getPortfolioStatisticsRows(
              portfolioStatisticsChartFilter({
                filteredPerformance,
                name: 'trailing_year_returns',
              }),
            )}
            columns={columnsTrailingYearReturns}
          />
        </Grid>
      )}
      <SlideParagraph
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          fontSize: '13px',
        }}
      >
        Source: TIFIN Sage
      </SlideParagraph>
    </Grid>
  );
}
